module.exports = __webpack_public_path__ + "c8899795db0b2a30ea72c4e2636526f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/low_20.jpg
// module id = 1735
// module chunks = 5